<template>
    <v-simple-table>
        <tbody v-if="value">
            <tr>
                <th>Name</th>
                <td>{{ value.name }}</td>
            </tr>
            <tr>
                <th>Abbreviation</th>
                <td>{{ value.abbreviation }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: "MeasureUnit",
    props: {
        value: Object
    }
}
</script>

<style>

</style>